import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { Form } from "react-bootstrap";
import "../../../styles/css/DropDownCheckbox.css";

export default class UserPicker extends Component {
    render() {
        const {
            data,
            labelText,
            disabled,
            ...rest
        } = this.props;

        return (
            <>
                <b><Form.Label>{labelText}</Form.Label></b>
                <DropdownTreeSelect
                    keepOpenOnSelect={false}
                    disabled={disabled}
                    clearSearchOnChange={true}
                    data={data}
                    {...rest}
                />
            </>
        );
    }
}